import "./TopRightNav.scss"
import React from 'react';
import {IconCurrencyMenu} from "../../icons";
import {useCurrencyState} from "../../store/CurrencyState";

export function TopRightNav() {
  const state = useCurrencyState()

  const currencyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    e.stopPropagation()
    state.toggleDrawer()
    return false
  }

  return <>
    <a href="#" onClick={currencyClick}>
      <IconCurrencyMenu/>
    </a>
    {/*<a href="#">*/}
    {/*  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
    {/*    <path d="M23 12H-2.38419e-07" stroke="currentColor" strokeWidth="3"/>*/}
    {/*    <path d="M23 22H7" stroke="currentColor" strokeWidth="3"/>*/}
    {/*    <path d="M16 2H-2.98023e-07" stroke="currentColor" strokeWidth="3"/>*/}
    {/*  </svg>*/}
    {/*</a>*/}
  </>

}